<template>
    <transition name="fade" class="clearfix">
        <div class="clearfix">
            <div class="notification" :class="classObj">
            {{ message }}
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name:'app-notification',
    props: ['level', 'message'],

    data() {
        return {
            noteClass: 'note content ' + this.level,
        };
    },

    computed: {
        classObj() {
            if(this.level === 'error' || this.level === 'failure') {
                return this.noteClass + ' has-text-danger';
            }
            return this.noteClass + ' has-text-success';
        },
    },

    methods: {
        onClick() {
            // console.log('emitted method sent TO parent');
            this.$emit('close');
        },
    },

    created() {
        // console.log('notification created ');
    }
};
</script>


<style>
    .fade-enter-active, .fade-leave-active {
      transition: background-color 0.15s ease-in;
    }

    .fade-enter, .fade-leave-to {
      background-color: transparent;
    }
    .note {
        /*padding: 1rem 0 ;*/
    }
    span.close.hide{
        display:none;
    }
    span.close {
        cursor: pointer;
    }
    .notification {
        background-color: transparent !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/Notifications.vue